module.exports = __webpack_public_path__ + "static/media/MainPage_2m.ea0592d2.png";